import { routes } from '../../../../../utils/helpers/ApiClient.jsx';

const withRecordId = (baseRoute, item) =>
  item?.record_id ? `${baseRoute}/${item.record_id}` : null;

const withCreateContext = (baseRoute, item, fixedParams = {}) => {
  const params = new URLSearchParams();
  const actionParams = item?.action_params || {};
  const supportedActionParams = {
    phd_student_id: actionParams.phd_student_id,
    phd_dissertation_exam_application_id:
      actionParams.phd_dissertation_exam_application_id,
    phd_dissertation_defense_application_id:
      actionParams.phd_dissertation_defense_application_id,
  };

  Object.entries({ ...fixedParams, ...supportedActionParams }).forEach(
    ([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.set(key, String(value));
      }
    },
  );

  const query = params.toString();
  return query ? `${baseRoute}?${query}` : baseRoute;
};

export const DASHBOARD_ACTION_ROUTES = {
  'student.edit': (item) => withRecordId(routes.cmsPhdStudentsEdit, item),
  'thesis.create': (item) => withCreateContext(routes.cmsPhdThesesCreate, item),
  'thesis.edit': (item) => withRecordId(routes.cmsPhdThesesEdit, item),
  'thesis.detail': (item) => withRecordId(routes.cmsPhdThesesDetail, item),
  'individual_plan.create': (item) =>
    withCreateContext(routes.cmsPhdIndividualPlansCreate, item),
  'individual_plan.edit': (item) =>
    withRecordId(routes.cmsPhdIndividualPlansEdit, item),
  'grades.create': (item) =>
    withCreateContext(routes.cmsPhdStudentEvaluationGradesCreate, item),
  'grades.edit': (item) =>
    withRecordId(routes.cmsPhdStudentEvaluationGradesEdit, item),
  'annual_evaluation.create': (item) =>
    withCreateContext(routes.cmsPhdStudentEvaluationsCreate, item),
  'annual_evaluation.edit': (item) =>
    withRecordId(routes.cmsPhdStudentEvaluationsEdit, item),
  'dissertation_exam_application.create': (item) =>
    withCreateContext(routes.cmsPhdApplicationsCreate, item, {
      type: 'dissertationExam',
    }),
  'dissertation_exam_application.edit': (item) =>
    withRecordId(routes.cmsPhdDissertationExamApplicationsEdit, item),
  'subjects_exam_application.create': (item) =>
    withCreateContext(routes.cmsPhdApplicationsCreate, item, {
      type: 'subjectsExam',
    }),
  'subjects_exam_application.edit': (item) =>
    withRecordId(routes.cmsPhdSubjectsExamApplicationsEdit, item),
  'defense_application.create': (item) =>
    withCreateContext(routes.cmsPhdApplicationsCreate, item, {
      type: 'dissertationDefense',
    }),
  'defense_application.edit': (item) =>
    withRecordId(routes.cmsPhdDissertationDefenseApplicationsEdit, item),
  'exam_examiner_proposal.create': (item) =>
    withCreateContext(
      routes.cmsPhdDissertationExamExaminerProposalsCreate,
      item,
    ),
  'exam_examiner_proposal.edit': (item) =>
    withRecordId(routes.cmsPhdDissertationExamExaminerProposalsEdit, item),
  'defense_examiner_proposal.create': (item) =>
    withCreateContext(
      routes.cmsPhdDissertationDefenseExaminerProposalsCreate,
      item,
    ),
  'defense_examiner_proposal.edit': (item) =>
    withRecordId(routes.cmsPhdDissertationDefenseExaminerProposalsEdit, item),
};

export const resolvePhdDashboardAction = (item) => {
  const resolver = DASHBOARD_ACTION_ROUTES[item?.action_key];

  if (!resolver) {
    return null;
  }

  return resolver(item);
};
